<template>
    <div>
        <!-- 题库管理 弹窗：编辑题库/创建题库 -->
        <el-dialog :title="questionForm.id?editTextConfig.edit:editTextConfig.add" v-if="questionDialogVisible"
                   :visible.sync="questionDialogVisible" width="500px" @close="close" :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <el-form :model="questionForm" :rules="rules" ref="questionForm" label-width="80px">
                <el-form-item :label="editTextConfig.form.name" prop="name">
                    <el-input v-model="questionForm.name" maxlength="100" show-word-limit clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">{{ editTextConfig.cancel }}</el-button>
                <el-button type="primary" @click="submitQuestionForm('questionForm')">
                    {{ editTextConfig.ok }}</el-button>
            </span>
        </el-dialog>
        <!-- 试卷管理 弹窗：复制试卷 -->
        <el-dialog :title="copyPaperForm.id?copyTextConfig.copy:copyTextConfig.add" v-if="copyPaperDialogVisible"
                   :visible.sync="copyPaperDialogVisible" width="500px" @close="copyPaperClose"
                   :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form :model="copyPaperForm" :rules="copyPaperRules" ref="copyPaperForm" label-width="80px">
                <el-form-item :label="copyTextConfig.form.name" prop="name">
                    <el-input v-model="copyPaperForm.name" maxlength="100" show-word-limit clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="copyPaperClose">{{ copyTextConfig.cancel }}</el-button>
                <el-button type="primary" @click="submitCopyPaperForm('copyPaperForm')">
                    {{ copyTextConfig.ok }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ['row', 'show', 'copyPaperShow', 'copyPaperRow'],
    data() {
        return {
            questionDialogVisible: false,
            questionForm: {
                id: null,
                name: '',
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: this.$store.state.global.textConfig.backend.questionBank.table.button.edit.form.nameRule,
                        trigger: 'change'
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (/^[\u4E00-\u9FA5A-Za-z0-9()（）]+$/g.test(value) == false && value) {
                                callback(new Error("仅支持输入中英文、数字、圆括号"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
            },
            copyPaperDialogVisible: false,
            copyPaperForm: {
                id: null,
                name: ''
            },
            copyPaperRules: {
                name: [
                    {
                        required: true,
                        message: this.$store.state.global.textConfig.backend.testPaper.table.button.copy.form.nameRule,
                        trigger: 'change'
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (/^[\u4E00-\u9FA5A-Za-z0-9()（）]+$/g.test(value) == false && value) {
                                callback(new Error("仅支持输入中英文、数字、圆括号"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
            },
        };
    },
    computed: {
        editTextConfig() {
            return this.$store.state.global.textConfig.backend.questionBank.table.button.edit
        },
        copyTextConfig() {
            return this.$store.state.global.textConfig.backend.testPaper.table.button.copy
        }
    },
    watch: {
        show() {
            this.questionDialogVisible = this.show;
        },
        row() {
            if (this.row) {
                this.questionForm.id = this.row.id
                this.questionForm.name = this.row.name
            } else {
                this.questionForm.id = null
                this.questionForm.name = ''
            }
        },
        copyPaperShow() {
            this.copyPaperDialogVisible = this.copyPaperShow;
        },
        copyPaperRow() {
            if (this.copyPaperRow) {
                this.copyPaperForm.id = this.copyPaperRow.id
                this.copyPaperForm.name = this.copyPaperRow.name
            } else {
                this.copyPaperForm.id = null
            }

        }
    },
    methods: {
        close() {
            this.questionDialogVisible = false
            this.questionForm.id = null
            this.questionForm.name = ''
            this.$emit('close', false)
        },
        copyPaperClose() {
            this.copyPaperDialogVisible = false
            this.copyPaperForm.id = null
            this.copyPaperForm.name = ''
            this.$emit('copyPaperClose', false)
        },
        submitQuestionForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.questionForm.id) {
                        this.$store.dispatch("putQuestion", this.questionForm).then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    message: this.editTextConfig.editSuccess,
                                    type: 'success'
                                });
                                this.$parent.search(1)
                                this.close()
                            }
                        });
                    } else {
                        this.$store.dispatch("postQuestion", this.questionForm).then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    message: this.editTextConfig.addSuccess,
                                    type: 'success'
                                });
                                this.close()
                                this.$parent.search(1)
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        submitCopyPaperForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.copyPaperForm.id) {
                        this.$store.dispatch("copyPaper", this.copyPaperForm).then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    message: this.copyTextConfig.copySuccess,
                                    type: 'success'
                                });
                                this.copyPaperClose()
                                this.$parent.search(1)
                            }
                        });
                    } else {
                        this.$store.dispatch("postPaper", this.copyPaperForm.name).then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    message: this.copyTextConfig.addSuccess,
                                    type: 'success'
                                });
                                this.$router.push({
                                    name: 'testPaperEdit',
                                    query: {id: res.data, name: this.copyPaperForm.name}
                                })
                                this.copyPaperClose()
                            }
                        });
                    }
                } else {
                    return false;
                }
            })
        }
    }
}
</script>

<style>

</style>
